export default (domNode: HTMLElement, attributeName = "appConfig") => {
  try {
    const attributeValue = domNode.dataset[attributeName] || "";

    return JSON.parse(attributeValue);
  } catch (error) {
    return {};
  }
};
